import {useFormik} from "formik";
import * as yup from "yup";
import {useTranslation} from "react-i18next";


const useWorkgroupForm = ({workgroup, onSubmit}) => {
    const {t} = useTranslation(['validation']);

    const formik = useFormik({
        initialValues: {
            name: workgroup?.name ?? "",
            icon: null,
            logo: null,
            visibility: workgroup?.visibility ?? "PUBLIC",
            propagate_visibility: false,
        },
        validationSchema: yup.object({
            name: yup
                .string()
                .required(t('validation:required')),
            icon: yup.mixed().nullable(),
            logo: yup.mixed().nullable(),
            visibility: yup.string().required(t('validation:required')),
        }),
        onSubmit: async (values) => {
            const data = values;
            for (const key in data) {
                if (data[key] === null) {
                    delete data[key];
                }
            }
            await onSubmit(data);
            formik.resetForm({values});
        }
    });

    return {formik};
}

export default useWorkgroupForm;